<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [transparentOverlay]="true"
  >
  <div class='scrollable-flex-content' [class.lm-panel-hidden]="showingOperatorBuilder">
    <div class="search-criteria-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
      <div class="field scope-criteria">
        <label soho-label for="item-desc">{{ 'FieldPicker_FieldNameLabel' | translate }}</label>
        <input
          id="item-desc"
          data-automation-id="lm-field-picker-field-name"
          [(ngModel)]="searchOptions.nameValue"
          (keydown.enter)="onSearchNameEnter($event)"
          soho-field-filter
          [fieldDropdownDataSet]="fieldNameComparators"
          (filtered)="onFieldNameComparatorChange($event)"
          />
        </div>
        @if (this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes') {
          <div class="field scope-criteria">
            <label soho-label for="relatedBusinessClassFilter">{{ 'FieldPicker_BusinessClassScopeLabel' | translate }}</label>
            <select
              id="relatedBusinessClassFilter"
              data-automation-id="lm-field-picker-fields-from"
              [attributes]="fieldsFromDropdownAttributes"
              soho-dropdown
              title="{{ 'FieldPicker_BusinessClassScopeTooltip' | translate }}"
              style="width: 200px;"
              [source]="businessClassSource"
              [(ngModel)]="relatedFieldFilter">
              <option class="clear"></option>
              @for (businessClass of businessClasses; track businessClass) {
                <option [value]="businessClass">{{businessClass}}</option>
              }
            </select>
          </div>
        }
        @if (this.options.view !== 'RelatedLinks' && this.options.view !== 'SimpleConditions' && this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes') {
          <div class="field scope-criteria">
            <label soho-label for="fieldType">{{ 'FieldPicker_FieldTypeLabel' | translate }}</label>
            <select
              soho-dropdown
              [ngClass]="'dropdown-md'"
              [multiple]="true"
              [closeOnSelect]="false"
              noSearch
              id="fieldType"
              [attributes]="fieldTypeDropdownAttributes"
              name="fieldType"
              style="width: 200px;"
              [(ngModel)]="includeOptions">
              @for (option of fieldTypes; track option) {
                <option
                [value]="option.value">{{option.label}}</option>
              }
            </select>
          </div>
        }
        @if (this.options.view !== 'RelatedLinks' && this.options.view !== 'Measures' && this.options.view !== 'Dimensions' && this.options.view !== 'DimensionsWithAttributes') {
          <div  class="field scope-criteria">
            <label soho-label for="searchScope">{{ 'FieldPicker_SearchDepthLabel' | translate }}</label>
            <select
              id="searchScope"
              [attributes]="searchScopeDropdownAttributes"
              soho-dropdown
              style="width: 250px;"
              [(ngModel)]="searchScope">
              <option [value]="'normal'">{{ 'FieldPicker_SearchDepthNormalLabel' | translate }}</option>
              <option [value]="'extended'">{{ 'FieldPicker_SearchDepthExtendedLabel' | translate }}</option>
              <option [value]="'max'">{{ 'FieldPicker_SearchDepthMaxLabel' | translate }}</option>
            </select>
          </div>
        }
      </div>
      <div>
        <div class="lm-search-button-container">
          <button id="fieldPickerSearchBtn" data-automation-id="lm-field-picker-search-button" soho-button="tertiary" class="btn-tertiary lm-run-search-button"
          (click)="onSearchClicked($event)">{{ 'Search' | translate }}</button>
          <button id="fieldPickerClearBtn" data-automation-id="lm-field-picker-clear-button" soho-button="tertiary" class="btn-tertiary lm-clear-search-button"
          (click)="onClearSearchClicked($event)">{{ 'Clear' | translate }}</button>
        </div>
        @if (searchingFromHere) {
          <lm-list-searchtags
            data-automation-id="lm-field-picker-focus-search-tags"
            automationIdPrefix="field-picker-focus"
            [showRefineAndClear]="false"
            [searchTags]="searchingFromHereTags"
            (searchTagRemoved)="onSearchTagRemoved($event)"
            [iconName]="searchingFromHereContext?.length > 1 ? 'left-arrow' : 'close'"
          ></lm-list-searchtags>
        }
      </div>
      <lm-notification #lmNotificationComponent data-automation-id="lm-field-picker-notification" [notificationType]="'info'" (lmNotificationEvent) = "onNotificationEvent($event)"></lm-notification>
      <div class="row lm-field-picker-datagrid-container">
        @if (gridOptions) {
          <lm-list-datagrid-wrapper #DatagridWrapper
            [dataGridAutomationId]="'lm-field-picker-data-grid'"
            [gridOptions]="gridOptions"
            [emptyMessage]="emptyMessage"
            (expandrow)="onExpandRow($event)"
            (collapserow)="onCollapseRow($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)"
            (rowClicked)="onRowSelected($event)"
          ></lm-list-datagrid-wrapper>
        }
      </div>
    </div>

    <ng-container id="operatorBuilderContainer">
      <div [class.lm-panel-hidden]="!showingOperatorBuilder">
        @if (options.view === 'Measures') {
          <h1 data-automation-id="lm-field-picker-header" class="fieldset-title lm-header-3">{{ 'FieldPicker_periodOperator_label' | translate }}</h1>
        }
        @if (options.view !== 'Measures') {
          <h1  class="fieldset-title lm-header-3">{{ 'FieldPicker_AddOperatorLabel' | translate }}</h1>
        }
        @if (showingOperatorBuilder) {
          <lm-field-picker-operator #OperatorView
            [uiFieldSpec] ="selectedRow"
            [operatorInfo] ="fieldOperatorInfo"
            [auditData] ="options.includeAuditFields"
            [view] ="options.view"
            [validPeriods]="options.validPeriods">
          </lm-field-picker-operator>
        }
      </div>
    </ng-container>
  </div>
